import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ld-paperless-settings-skeleton',
  template: `
    <div id="paperless-settings-skeleton" class="flex flex-col gap-6 animate-pulse">
      <!-- Main Card -->
      <div class="bg-white rounded-3xl border border-ld-border overflow-hidden">
        <!-- Header Section -->
        <div class="px-8 py-6 border-b border-ld-border">
          <div class="h-7 w-48 bg-gray-200 rounded mb-2"></div>
          <div class="h-4 w-96 bg-gray-200 rounded"></div>
        </div>

        <!-- Select All Toggle -->
        <div class="px-8 py-4 border-b border-ld-border flex items-center justify-between">
          <div class="h-5 w-20 bg-gray-200 rounded"></div>
          <div class="w-12 h-6 bg-gray-200 rounded-full"></div>
        </div>

        <!-- Document Toggles -->
        <div class="divide-y divide-ld-border">
          @for (item of [1, 2, 3, 4]; track item) {
          <div class="px-8 py-4 flex items-center justify-between">
            <div class="flex-1">
              <div class="h-5 w-48 bg-gray-200 rounded mb-1"></div>
              <div class="h-4 w-72 bg-gray-200 rounded"></div>
            </div>
            <div class="w-12 h-6 bg-gray-200 rounded-full"></div>
          </div>
          }
        </div>

        <!-- Footer with Save Button -->
        <div class="px-8 py-6 border-t border-ld-border flex justify-end">
          <div class="h-12 w-32 bg-gray-200 rounded-lg"></div>
        </div>
      </div>

      <!-- Email Section Card -->
      <div class="bg-white rounded-3xl border border-ld-border overflow-hidden p-8">
        <div class="h-6 w-32 bg-purple-100 rounded mb-4"></div>
        <div class="h-4 w-64 bg-gray-200 rounded mb-2"></div>
        <div class="h-4 w-48 bg-blue-100 rounded"></div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaperlessSettingsSkeletonComponent {}
